module.exports = __webpack_public_path__ + "img/head.b2f2906a.png";